export interface UsuarioDosTermosDeUso {
  compMan: {
    acceptedTerms: boolean
    boraStatus?: string | null
  }
  roleGroup: {
    kind: string
  }
  email: string
  ehDeSuporte: boolean
}

export function deveExibirTermosDeUso (usuario?: UsuarioDosTermosDeUso | null): boolean {
  try {
    if (!usuario) return false

    const { compMan, roleGroup, email, ehDeSuporte } = usuario

    const aindaNaoAceitouTermosDeUso = !compMan.acceptedTerms
    const naoEhUsuarioDeSuporte = !email.includes('lar21@') && !ehDeSuporte
    const ehUsuarioComPermissaoRh = roleGroup.kind === 'all'

    return aindaNaoAceitouTermosDeUso && naoEhUsuarioDeSuporte && ehUsuarioComPermissaoRh
  } catch {
    return false
  }
}
